import React from 'react';
import { Building2 } from 'lucide-react';
import { COUNTRIES } from '.';

export const defaultListedCompanyQuestions = [
  {
    id: 'logo',
    placeholder: 'logo',
    title: 'uploadLogo',
    type: 'avatar',
    image: <Building2 size={60} className='file-icon' />,
    mandatory: false,
  },
  {
    id: 'name',
    type: 'text',
    title: 'name',
    placeholder: 'name',
    mandatory: true,
  },
  {
    id: 'description',
    type: 'textarea',
    title: 'description',
    placeholder: 'description',
    mandatory: true,
  },
  {
    id: 'website',
    type: 'text',
    title: 'website',
    placeholder: 'website',
    mandatory: false,
  },
  {
    id: 'currency',
    title: 'currency',
    placeholder: 'currency',
    type: 'select',
    answers: ['USD', 'EUR', 'GBP', 'CHF', 'CNY', 'HKD', 'JPY', 'AUD'],
    mandatory: false,
  },
  {
    id: 'taxId',
    type: 'text',
    title: 'taxid',
    placeholder: 'taxid',
    mandatory: false,
  },
  {
    id: 'incorporationDate',
    type: 'date',
    title: 'incorporationDate',
    placeholder: 'incorporationDate',
    mandatory: false,
  },
  {
    id: 'country',
    mandatory: false,
    placeholder: 'country',
    title: 'country',
    type: 'select',
    answers: COUNTRIES,
    literals: 'countries',
  },
  {
    id: 'registeredAddress',
    type: 'text',
    title: 'registeredAddress',
    placeholder: 'registeredAddress',
    mandatory: false,
  },
  {
    id: 'sector',
    type: 'text',
    title: 'sector',
    placeholder: 'sector',
    mandatory: false,
  },
  {
    id: 'ticker',
    type: 'text',
    title: 'ticker',
    placeholder: 'ticker',
    mandatory: false,
  },
  {
    id: 'exchangeListing',
    type: 'select',
    title: 'exchangeListing',
    placeholder: 'exchangeListing',
    answers: ['NASDAQ', 'NYSE', 'AMEX', 'Other'],
    mandatory: false,
  },
  {
    id: 'contactName',
    type: 'text',
    title: 'contactName',
    placeholder: 'contactName',
    mandatory: false,
  },
  {
    id: 'contactEmail',
    type: 'email',
    title: 'contactEmail',
    placeholder: 'contactEmail',
    mandatory: false,
  },
];
